<script setup>
import {defineEmits, defineProps, onMounted, ref, computed} from 'vue'

import {Dialog} from '@progress/kendo-vue-dialogs'
import {Button} from '@progress/kendo-vue-buttons'
import {Grid, GridNoRecords} from '@progress/kendo-vue-grid'
import {debounce} from 'lodash'
import {Input} from '@progress/kendo-vue-inputs'

import api from '@/api/index'

const props = defineProps({
  type: {
    type: String,
  },
})

const emits = defineEmits(['accept', 'cancel'])

const items = ref([])
const isLoading = ref(true)

const skip = ref(0)
const take = ref(20)
const total = ref(0)
const columns = [
  {field: 'name', title: 'Название поставщика'},
  {cell: 'operation', filterable: false, width: '150px'},
]
const filters = ref({
  page: 1,
  name: '',
})

const title = computed(() => {
  return props.type === 'service' ? 'Выберите услугу' : 'Выберите товар'
})

const onCancel = () => {
  emits('cancel')
}

const getData = async () => {
  try {
    let response = null

    filters.value.limit = 100

    if (props.type === 'service') {
      response = await api.services.get(filters.value)
    } else {
      response = await api.products.get(filters.value)
    }

    items.value = response.data.data
    total.value = response.data.total
  } catch (err) {
    console.error('Ошибка при получении данных', err)
  } finally {
    isLoading.value = false
  }
}

const onSelect = (item) => {
  emits('accept', item)
}

const dataStateChange = (dataState) => {
  take.value = dataState.data.take
  skip.value = dataState.data.skip

  filters.value.page = Math.floor(Number(skip.value) / Number(take.value)) + 1
  getData()
}

const onInputName = debounce(() => {
  filters.value.page = 1
  skip.value = 0
  getData()
}, 500)

onMounted(() => {
  getData()
})
</script>

<template>
  <Dialog
      :width="800"
      :height="500"
      @save="onAccept"
      @cancel="onCancel"
  >
    <div class="modal-offerings">
      <h3 class="modal-offerings__title">{{ title }}</h3>

      <div class="modal-offerings__content">
        <div class="modal-offerings__filters">
          <Input
              v-model="filters.name"
              placeholder="Введите название"
              @input="onInputName"
          />
        </div>

        <Grid
            ref="grid"
            :data-items="items"
            :edit-field="'inEdit'"
            :pageable="true"
            :take="take"
            :skip="skip"
            :total="total"
            :loader="isLoading"
            :columns="columns"
            @datastatechange="dataStateChange"
        >
          <template v-slot:operation="{ props }">
            <td class="k-command-cell k-table-td">
              <div class="cell-control">
                <Button
                    :theme-color="'primary'"
                    class="k-grid-edit-command"
                    @click.prevent="onSelect(props.dataItem)"
                >
                  Выбрать
                </Button>
              </div>
            </td>
          </template>

          <GridNoRecords>Нет данных</GridNoRecords>
        </Grid>
      </div>

      <div class="modal-offerings__footer custom-modal-footer">
        <Button @click="onCancel">Отмена</Button>
      </div>
    </div>
  </Dialog>
</template>

<style scoped lang="scss">
.modal-offerings {
  &__title {
    font-size: 24px;
    margin-bottom: 1rem;
  }

  &__filters {
    margin-bottom: 1rem;
  }
}
</style>